/* eslint-disable no-useless-computed-key */
import React, { useState, useEffect, ChangeEvent } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  SelectChangeEvent,
  Grid,
  Paper
} from "@mui/material";
import { useNotification } from "../../context/notification.context";
import { payments } from "../../api/pays";
import copy from 'clipboard-copy';

type ModalPaymentProps = {
  open: boolean;
  onClose: () => void;
  title: string; 
  initialData?: any | null;
  providerID: number;
  productType: string;
  productID: number;
  file: string;
  cliente: string;
};

export const ModalPaymentProductComponent: React.FC<ModalPaymentProps> = ({
  open,
  onClose,
  title,
  initialData,
  providerID,
  productType,
  productID,
  file,
  cliente
}) => {
  const [formData, setFormData] = useState<any>({});
  const { getError, getSuccess } = useNotification();

  useEffect(() => {    
    if (initialData) {      
      setFormData(initialData);
    } else {
      setFormData({});
    }
  }, [initialData]);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | { name: string; value: unknown }> | SelectChangeEvent<any>,
  ) => {
    const { name, value } = event.target as HTMLInputElement;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
    if(name === "valorDeCambioLit"){  
      setFormData((prevData: any) => ({
        ...prevData,
        ["importe_usd"]: (formData["importeLit"] / parseFloat(value)).toFixed(2),
      }));
    }
    if(name === "importeLit"){    
      setFormData((prevData: any) => ({
        ...prevData,
        ["importe_usd"]: (parseFloat(value) / formData["valorDeCambioLit"]).toFixed(2),
      }));
    }
    if(name === "importe_usd"){
      const importe = (value !== "") ? (parseFloat(value) * parseFloat(formData["valorDeCambioLit"])).toFixed(2) : 0;
      setFormData((prevData: any) => ({
        ...prevData,
        ["importeLit"]: importe,
      }));
    }
  };

  const handleClose = () => {  
    //setFormData({});
    onClose();
  }

  const handleSave = async (withCopy: boolean) => {    
      try {  
        const importe = formData["importeLit"]; 
        if(importe !== undefined && parseFloat(importe) > 0){  
          const imputacionPago = { 
            file: file,
            cliente: cliente,
            importe: importe,
          }         
          let paymentData = {};
          switch(productType) {
            case 'Alojamiento':
              paymentData = {
                moneda: (formData["moneda"] === undefined) ? "$" : formData["moneda"],
                importe: (formData["moneda"] === "U$S") ? formData["importe_usd"] : importe,
                proveedorId: providerID,
                hotelId: productID,
                valorDeCambio: (formData["valorDeCambioLit"] === undefined) ? 1 : formData["valorDeCambioLit"],
                observaciones: formData["observaciones"],
              };    
              break;
            case 'Aéreo':       
              paymentData = {
                moneda: (formData["moneda"] === undefined) ? "$" : formData["moneda"],
                importe: (formData["moneda"] === "U$S") ? formData["importe_usd"] : importe,
                proveedorId: providerID,
                aereoId: productID,
                valorDeCambio: (formData["valorDeCambioLit"] === undefined) ? 1 : formData["valorDeCambioLit"],
                observaciones: formData["observaciones"],
              };  
              break;
            case 'Servicio':
              paymentData = {
                moneda: (formData["moneda"] === undefined) ? "$" : formData["moneda"],
                importe: (formData["moneda"] === "U$S") ? formData["importe_usd"] : importe,
                proveedorId: providerID,
                servicioId: productID,
                valorDeCambio: (formData["valorDeCambioLit"] === undefined) ? 1 : formData["valorDeCambioLit"],
                observaciones: formData["observaciones"],
              }; 
              break;
          }
          await payments.create(paymentData);
          setFormData({});   
          if(withCopy) handleCopy(imputacionPago);              
          getSuccess("Pago agregado correctamente");      
          handleClose();    
        }else{
          getError("El importe debe ser mayor a cero");
        }
      } catch (error) {
        getError("Error al agregar el pago: " + error);
      }
  };

  const handleUpdate = async (withCopy: boolean) => {     
    try {  
      const importe = formData["importeLit"]; 
      if(importe !== undefined && parseFloat(importe) > 0){     
        const imputacionPago = { 
          file: file,
          cliente: cliente,
          importe: importe,
        }   
        const paymentData = {
          moneda: (formData["moneda"] === undefined) ? "$" : formData["moneda"],
          importe: (formData["moneda"] === "U$S") ? formData["importe_usd"] : importe,
          valorDeCambio: (formData["valorDeCambioLit"] === undefined) ? 1 : formData["valorDeCambioLit"],
          observaciones: formData["observaciones"],
        };  
        await payments.update(initialData.id, paymentData);
        setFormData({});          
        if(withCopy) handleCopy(imputacionPago);     
        getSuccess("Pago editado correctamente");            
        handleClose();    
      }else{
        getError("El importe debe ser mayor a cero");
      }  
    } catch (error) {
      getError("Error al editar el pago: " + error);
    }
  };

  function handleCopy(imputacionPago: any){
    const importe = (formData["moneda"] === "$" || formData["moneda"] === undefined) ? "$ " + formData["importeLit"] : (formData[`importe_usd`] !== undefined) ? "U$S " + formData[`importe_usd`] : (formData[`importeLit`] !== undefined && formData[`valorDeCambioLit`] !== undefined) ? "U$S " + (parseFloat(formData[`importeLit`]) / parseFloat(formData[`valorDeCambioLit`])) : ""; 
    const data = formatDataAsString(importe, imputacionPago);
    copy(data);
  }

  //format data as string for copy to clipboard
  const formatDataAsString = (importe: string, imputacionPago: any) => {
    const moneda = formData["moneda"] || "$";
    const valorDeCambio = formData["valorDeCambioLit"];
    const importePesos = formData["importeLit"];
    const importeUsd = formData["importe_usd"];
    
    // Encabezado
    let formattedString = '';
    if (moneda === "U$S" && importePesos && valorDeCambio && importeUsd) {
      // Si es U$S: mostrar Total pesos, Tipo de cambio, Total dólares
      formattedString += `Total: $ ${importePesos}  \n`;
      formattedString += `Tipo de Cambio: $ ${valorDeCambio}  \n`;
      formattedString += `Total: U$S ${importeUsd}  \n\n`;
    } else {
      // Si es pesos: solo mostrar el total
      formattedString += `Total: ${importe}\n\n`;
    }
    
    formattedString += '------------------------------------------\n';
    
    // Imputación (sin tipo de cambio repetido)
    formattedString += `File: ${imputacionPago.file}  \n`;
    formattedString += `Pax: ${imputacionPago.cliente}  \n`;
    formattedString += `Importe: ${importe}  \n`;
    formattedString += `Saldo: ${imputacionPago.saldo ? imputacionPago.saldo : ''}  \n`;
    formattedString += '------------------------------------------\n';
    
    return formattedString;
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container>          
          <Grid item xs={2} sx={{ mr: 3 }}>
              <InputLabel sx={{ mt: 1 }}>
                Moneda
              </InputLabel>
              <Select
                key={`moneda`}
                label={`moneda-label`}
                id={`moneda`}
                name={`moneda`}
                value={formData[`moneda`] || "$"}
                onChange={handleChange} 
                fullWidth
              >
                  <MenuItem key={"$"} value={"$"} selected={true}>
                    {"$"}
                  </MenuItem>
                  <MenuItem key={"U$S"} value={"U$S"}>
                    {"U$S"}
                  </MenuItem>
              </Select>             
          </Grid>
          <Grid item xs={3} sx={{ mr: 3 }}>
            <InputLabel sx={{ mt: 1 }}>
              Importe
            </InputLabel>
            <TextField
              key={"importeLit"}              
              name={"importeLit"}
              fullWidth
              sx={{ mt: 0 }}
              type={"number"}
              onChange={handleChange}
              value={formData[`importeLit`]}
            />
          </Grid>
          {formData["moneda"] === "U$S" && (
            <>
            <Grid item xs={3} sx={{ mr: 2 }}>                
              <InputLabel sx={{ mt: 1 }}>
                Tipo de Cambio
              </InputLabel>
              <TextField
                key={"valorDeCambioLit"}
                name={"valorDeCambioLit"}
                fullWidth
                sx={{ mt: 0 }}
                type={"number"}
                onChange={handleChange}
                value={formData[`valorDeCambioLit`]}
              />
            </Grid>
            <Grid item xs={3}>                
              <InputLabel sx={{ mt: 1 }}>
                Conversión U$S
              </InputLabel>
              <TextField
                key={"importe_usd"}
                name={"importe_usd"}
                fullWidth
                sx={{ mt: 0 }}
                type={"number"}
                value={(formData[`importe_usd`] !== undefined) ? formData[`importe_usd`] : (formData[`importeLit`] !== undefined && formData[`valorDeCambioLit`] !== undefined) ? (parseFloat(formData[`importeLit`]) / parseFloat(formData[`valorDeCambioLit`])) : undefined}
                onChange={handleChange}
              />
            </Grid>
            </>  
          )}
        </Grid>
        <Grid container sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={12}>
            <InputLabel sx={{ mt: 1 }}>
              Observaciones
            </InputLabel>
            <TextField
              key={"observaciones"}              
              name={"observaciones"}
              multiline={true}
              rows={4}
              fullWidth
              sx={{ mt: 0 }}
              onChange={handleChange}
              value={formData[`observaciones`] || ""}
            />
          </Grid>
        </Grid>        
        <Paper variant="outlined" />   
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} style={{backgroundColor:"#ed3c3cde", color:"#000000"}}>Cancelar</Button>
        <Button onClick={initialData && Object.keys(initialData).length > 0 ? () => {handleUpdate(false);} : () => {handleSave(false);}} style={{backgroundColor:"#6da34cde", color:"#000000"}}>Solo Guardar</Button>
        <Button onClick={initialData && Object.keys(initialData).length > 0 ? () => {handleUpdate(true);} : () => {handleSave(true);}} style={{backgroundColor:"#3c8fedde", color:"#000000"}}>Guardar y Copiar Imputaciones</Button>
      </DialogActions>
    </Dialog>
  );
};
